<div *ngIf="loading()" class="loading-container">
  <ng-lottie [options]="options()" width="90px" />
</div>
